import { NgModule } from '@angular/core';

import { FilterPipe, LIB_CommonModule, SearchPipe, SorterPipe } from 'pbc.angular';

import { OrtKategoriesService } from '.';

@NgModule({
  imports: [LIB_CommonModule],
  providers: [OrtKategoriesService, SearchPipe, FilterPipe, SorterPipe],
  exports: [],
})
export class OrtKategoriesServiceModule {}
